import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {AppStateService, AppWindowState} from '../../../app-common/services/appState/app-state.service';
import {AuthService} from '../auth/auth.service';
import {TenantService} from '../tenant/tenant.service';
import {UserService} from '../../../user/services/user/user.service';
import {LoggerService} from '../../../logging/services/logger.service';
import {LogLevel} from '../../../logging/data/logLevel';
import {LogSourceType} from '../../../logging/data/logSourceType';
import {LogSource} from '../../../logging/data/logSource';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(private appStateService: AppStateService,
              private router: Router,
              private authService: AuthService,
              private tenantService: TenantService,
              private userService: UserService,
              private loggerService: LoggerService) {
  }

  async canActivate() {
    if (this.appStateService.appWindowState === AppWindowState.Main) {
      return true;
    } else {
      if (!localStorage.getItem('jwtToken') || !localStorage.getItem('tenantDto')) {
        this.loggerService.logMessage(LogLevel.WARN, LogSourceType.SERVICE, LogSource.AuthGuard, 'User is not logged in, navigating to login page');
        this.router.navigate(['/login']);
        return false;
      }
      await new Promise<void>(async (resolve, reject) => {
        while (!this.authService.jwtToken || !this.tenantService.authenticated || !this.userService.currentUser) {
          await new Promise<void>((res, rej) => {
            setTimeout(() => {
              res();
            }, 100);
          });
        }
        resolve();
      });
      return true;
    }
    return false;
  }
}
